import { makeActionFactory } from './actionFactory';
import { AlarmMap, AlarmId } from 'types';

export type ActionType =
    'ALARM_RECEIVED'
    | 'ALARMS_LOAD_REQUEST'
    | 'ALARMS_LOAD_SUCCESS'
    | 'ALARMS_LOAD_FAILURE'
    | 'DISPLAY_ALARM'
;

const actionFactory = makeActionFactory<ActionType>();


//
//  ALARM_RECEIVED action notifies the app that an alarm was received
//  (asynchronously via server push rather than us loading them)
//
export interface AlarmReceivedAction {
    type: 'ALARM_RECEIVED';
    payload: AlarmMap;
}
export const alarmReceived = actionFactory.payload<AlarmReceivedAction, AlarmMap>('ALARM_RECEIVED');


//
//  ALARMS_LOAD_REQUEST action notifies the app that we're trying to load alarms
//
export interface AlarmsLoadRequestAction {
    type: 'ALARMS_LOAD_REQUEST';
    payload: Date;
    // TODO: page size? last id (e.g. for infinite scrolling)?
}
export const alarmsLoadRequest = actionFactory.payload<AlarmsLoadRequestAction, Date>('ALARMS_LOAD_REQUEST');


//
//  ALARMS_LOAD_SUCCESS action notifies the app that we successfully loaded alarms
//
export interface AlarmsLoadSuccessAction {
    type: 'ALARMS_LOAD_SUCCESS';
    payload: AlarmMap;
    meta: {
        utcDate: Date;
    };
}
export const alarmsLoadSuccess = actionFactory.payloadMeta<AlarmsLoadSuccessAction, AlarmMap, { utcDate: Date }>('ALARMS_LOAD_SUCCESS');


//
//  ALARMS_LOAD_FAILURE action notifies the app that we failed to load alarms
//
export interface AlarmsLoadFailureAction {
    type: 'ALARMS_LOAD_FAILURE';
    payload: Error;
    error: true;
    meta: {
        utcDate: Date;
    };
}
export const alarmsLoadFailure = actionFactory.errorMeta<AlarmsLoadFailureAction, { utcDate: Date }>('ALARMS_LOAD_FAILURE');


//
//  DISPLAY_ALARM action tells the app to look up the device and time for the given alarm and display it in the active monitoring cell
//
export interface DisplayAlarmAction {
    type: 'DISPLAY_ALARM';
    payload: AlarmId;
}
export const displayAlarm = actionFactory.payload<DisplayAlarmAction, AlarmId>('DISPLAY_ALARM');



// WEBPACK FOOTER //
// ./src/actions/alarmActions.ts